module.exports = __webpack_public_path__ + "static/media/eng_d_2304.d071b148.mp4";